// --------------------------------------------------------
// CARD PAINEL CONSULTS MODAL - CardPainelConsultsModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useCallback, useState } from "react";
import Colors from "../../constants/Colors";
import {
  ScheduleConsultType,
  UpdateStatus,
} from "../../core/http/service/SchedulingService";
import { Button } from "../../pages/company/companyRegister/CompanyRegister.styled";
import {
  ContainerInfoUser,
  DivStatusPacient,
  InfoUserModal,
  ModalPainelConsultsButtonsContainer,
  ModalPainelConsultsCardContainer,
  ModalPainelConsultsTextCardContainer,
  PainelConsultsCardModal,
  PainelConsultsCardModalContainer,
} from "./CardPainelConsultsModal.styled";

import { H1, Text } from "../UI/generalLayout/Layout.styled";
import { Spacer } from "../UI/spacer/spacer";
import { Avatar, Radio } from "@mui/material";
import { DivHorario } from "./CardPainelConsults.styled";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import moment from "moment";
import { AppointmentStatus, getEnumAsObject } from "../../enums/AppointmentStatus";
import * as appointmentActions from '../../store/actions/appointment';
import { CollaboratorInitialSchedulingModalRadioHeader } from "../collaboratorInitial/CollaboratorInitialSchedulingModal.styled";
import { useAppDispatch } from "../..";
import { PessoaPainel } from "./CardPainelConsults";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARD PAINEL CONSULTS MODAL INTERFACE
// --------------------------------------------------------

interface ICardPainelConsultsModal {
  modalOpen: boolean;
  onCloseModal: () => void;
  onSaveStatus: ()=> void;
  data: any;
  photo: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardPainelConsultsModal = ({
  modalOpen,
  onCloseModal,
  onSaveStatus,
  data,
  photo,
}: ICardPainelConsultsModal) => {
  // --------------------------------------------------------
  // CARD PAINEL CONSULTS MODAL PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [selectedRadio, setSelectedRadio] = useState<
    AppointmentStatus
  >();
  const dispatch = useAppDispatch();
  const onConfirmSchedule = async () => {
    updateAppointmentStatus();
    onSaveStatus();
    onCloseModal();
  };

  const updateAppointmentStatus = useCallback(async ()=>{
    await dispatch(appointmentActions.updateAttendanceStatus(data.id, selectedRadio?.valueOf() ?? ''))
  }, [selectedRadio, data])

  const pessoa: PessoaPainel = data;
  const horario = moment(data.horario, 'YYYY-MM-DDTHH:mm').format('HH:mm')
  const attendanceStatusValues = getEnumAsObject()
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <PainelConsultsCardModal open={modalOpen}>
      <PainelConsultsCardModalContainer>
        <ModalPainelConsultsCardContainer>
          <ModalPainelConsultsTextCardContainer>
            <H1
              color="#07365F"
              bold={true}
              style={{
                fontWeight: 700,
              }}
            >
              Atualizar status do paciente
            </H1>
            <Text>
              Altere o status do paciente para a atual situação que ele está.
            </Text>
          </ModalPainelConsultsTextCardContainer>
          <ContainerInfoUser>
            <InfoUserModal>
              <Avatar src={photo} alt="" />
              <p>{pessoa.nome}</p>
            </InfoUserModal>
            <DivHorario>
              <AccessTimeIcon />
              {horario}
            </DivHorario>
          </ContainerInfoUser>
          <Spacer bottom={20} />
          <DivStatusPacient>
            {"Status do paciente:"}
            {attendanceStatusValues.map(value => {
              return <CollaboratorInitialSchedulingModalRadioHeader>
                <Radio
                  checked={selectedRadio === value.value}
                  onChange={() => setSelectedRadio(value.value)}
                />
                <H1 style={{ color: "#0A5190", fontSize: 17 }}>{value.desc}</H1>
              </CollaboratorInitialSchedulingModalRadioHeader>
            })}
          </DivStatusPacient>
          <Spacer bottom={10} />

          <Spacer bottom={30} />
          <ModalPainelConsultsButtonsContainer>
            <Button
              onClick={onCloseModal}
              color={Colors.lightBlue}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.lightBlue}
            >
              Cancelar
            </Button>
            <Button
              onClick={onConfirmSchedule}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
              disabled={!selectedRadio}
            >
              Salvar Status
            </Button>
          </ModalPainelConsultsButtonsContainer>
        </ModalPainelConsultsCardContainer>
      </PainelConsultsCardModalContainer>
    </PainelConsultsCardModal>
  );
  // --------------------------------------------------------
};

export default CardPainelConsultsModal;
